import { createRouter, createWebHistory } from 'vue-router'
import Home from '@/views/Home.vue'
import Cases from '@/views/Cases.vue'
import Case from '@/views/Case.vue'
import Inventory from '@/views/Inventory.vue'
import Market from '@/views/Market.vue'
import Rewards from '@/views/Rewards.vue'
import Invites from '@/views/Invites.vue'
import Battles from '@/views/battles/index.vue'
import BattlesCreate from './battles/Create.vue'
import Battle from './battles/Battle.vue'
import ProfileIndex from '@/views/Profile/index.vue'
import ProfileFairness from '@/views/Profile/Fairness.vue'
import ProfileTransactions from '@/views/Profile/Transactions.vue'
import Verify from '@/views/Verify.vue'
import Onboarding from '@/views/Onboarding.vue'
import Tests from './Tests.vue'

const router = createRouter({
	history: createWebHistory(import.meta.env.BASE_URL),
	routes: [
		{
			path: '/',
			component: Home
		},
		{
			path: '/tests',
			component: Tests
		},
		{
			path: '/cases',
			component: Cases
		},
		{
			path: '/onboarding',
			component: Onboarding
		},
		{
			path: '/battles',
			component: Battles
		},
		{
			path: '/battles/create',
			component: BattlesCreate
		},
		{
			path: '/battle/:uuid',
			props: true,
			component: Battle
		},
		{
			path: '/case/:uuid',
			props: true,
			component: Case
		},
		{
			path: '/inventory',
			component: Inventory
		},
		{
			path: '/market',
			component: Market
		},
		{
			path: '/rewards',
			component: Rewards
		},
		{
			path: '/invites',
			component: Invites
		},
		{
			path: '/profile',
			component: ProfileIndex,
			children: [
				{
					path: '',
					component: ProfileFairness
				},
				{
					path: 'transactions',
					component: ProfileTransactions
				}
			]
		},
		{
			path: '/verify',
			component: Verify
		}
	]
})

router.afterEach(() => {
	const view = document.getElementById('view')

	if (!view) {
		return
	}

	view.scrollTo(0, 0)
})

export default router
